<script>

import {Colors} from '../colors.js'

export default {
  name: 'Expandable',

  props: {
    title: String,
    value: Boolean,
    color: String,
    colorIndex: Number
  },

  data() {
    return {
      lineColor: null,
      internalVisible: null
    }
  },

  methods: {
    getDefaultColor() {
      if (this.colorIndex) {
        return Colors.get(this.colorIndex);
      }
      if (window.expandalbeColorIndex == undefined) {
        window.expandalbeColorIndex = -1;
      }
      window.expandalbeColorIndex += 1;
      return Colors.get(window.expandalbeColorIndex);
    },

    toggle() {
      this.internalVisible = !this.internalVisible;
    }
  },

  mounted() {
    this.lineColor = this.color || this.getDefaultColor();
    this.internalVisible = this.value;
  },

  computed: {
    styles() {
      return {
        'background-color': this.lineColor
      }
    }
  },

  watch: {
    internalVisible() { this.$emit('input', this.internalVisible); },
    color() {
      this.lineColor = this.color || this.getDefaultColor();
    }
  }

}
</script>

<template>
  <div class="expandable">
    <div class="line" :style="styles"></div>
    <h3 @click="toggle" :class="{'small-title': !internalVisible, 'visible': internalVisible}">
      <span v-if="internalVisible" class="left">▼</span>
      <span v-else class="left">►</span>

      {{title}}
    </h3>

    <div v-if="internalVisible">
      <slot/>
    </div>
  </div>

</template>

<style scoped>
.left {
  float: left;
}

.expandable {
  padding-left: 35px;
  position: relative;
}

h3 {
  cursor: pointer;
}

h3.small-title {
  font-size: 1.3rem;
}

h3.visible {
  padding-top: 10px;
  padding-bottom: 10px;
}

.line {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  background-color: #F29766;
}
</style>
